/**
 * The per-stage timestamp strip, laid out for a TABLE cell (2026-08-06).
 *
 * Same pips, same done/pending vocabulary and the same hover-for-the-exact-time
 * behaviour as the 3-column grid `/inbox/threads/:id` still uses — but one flat
 * row, because a pipeline row has to stay about two lines tall for a table to be
 * worth having over the cards it replaced.
 */

import { studioFormat } from "../lib/studio-tz";

const DATE_OPTS: Intl.DateTimeFormatOptions = { month: "short", day: "2-digit" };
const DATETIME_OPTS: Intl.DateTimeFormatOptions = {
  month: "short",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
};

/** Studio-time, never browser-local — the studio is in London, Mario is not. */
function fmt(iso: string, opts: Intl.DateTimeFormatOptions): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : studioFormat(opts).format(d);
}

export interface ProgressStripStep {
  readonly stage: string;
  readonly label: string;
  readonly at: string | null;
}

export function ProgressStrip({
  steps,
}: {
  readonly steps: ReadonlyArray<ProgressStripStep>;
}): JSX.Element {
  return (
    <ol className="pr-progress-inline">
      {steps.map((s) => (
        <li
          key={s.stage}
          className={`pr-pip${s.at !== null ? " done" : ""}`}
          title={
            s.at !== null ? `${s.label} · ${fmt(s.at, DATETIME_OPTS)}` : s.label
          }
        >
          <span className="pr-pip-label">{s.label}</span>
          <span className="pr-pip-at">
            {s.at === null ? "—" : fmt(s.at, DATE_OPTS)}
          </span>
        </li>
      ))}
    </ol>
  );
}
